// extracted by mini-css-extract-plugin
export default {"content":"J0kSGzL60j","heading":"KxtnbfrhWP","disclaimerTrigger":"bGn4gV2VRm","paragraph":"tW5_bE3RBs","list":"gwz5bRr2TM","enquireRow":"rEe8iBWphx","primaryCta":"vtybaYgX53"};